import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';
import WaveDivider from '../components/WaveDivider';

export default function BaadtransportPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <SEO
        title="Bådtransport | JT transportsejlads"
        description="Lad mig klare opgaven for dig Hos tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til bådtransport eller flytning af båd, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, ... Læs Mere"
        ogTitle="Bådtransport | JT transportsejlads"
        ogDescription="Lad mig klare opgaven for dig Hos tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til bådtransport eller flytning af båd, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, ... Læs Mere"
        ogImage="https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg"
      />

      {/* Page Header */}
      <section className="relative bg-maritime-950 text-white pt-32 pb-20 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-45">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg"
            alt="Bådtransport sejlads på vandet"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-maritime-950 via-maritime-950/80 to-maritime-950/60" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white mb-6">
            Bådtransport
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto">
            Professionel hjælp til flytning og transport af både på vandet og mellem havne i hele Østjylland.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href="tel:+4550510062"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">+45 50 51 00 62</span>
            </a>
            <a
              href="mailto:johann2@hotmail.com"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-envelope text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">johann2@hotmail.com</span>
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 inset-x-0">
          <WaveDivider fill="#f8fafc" />
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-16 sm:py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Section: Lad mig klare opgaven for dig */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80 space-y-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
              Lad mig klare opgaven for dig
            </h2>

            <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
              Hos JT transportsejlads tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til <Link to="/baadtransport" className="text-cyan-700 underline font-medium hover:text-cyan-600">bådtransport</Link> eller <Link to="/" className="text-cyan-700 underline font-medium hover:text-cyan-600">flytning af båd</Link>, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, så kontakt mig endelig.
            </p>
          </div>

          {/* Grid of Two Columns: Grundig kommunikation & Høj kvalitet */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200/80 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-cyan-50 text-cyan-600 flex items-center justify-center text-xl">
                <i className="fa-solid fa-comments" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 tracking-tight">
                Grundig kommunikation fra start
              </h3>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Jeg har stor forståelse for, at mine kunders behov og ønsker kan variere, så jeg tager altid en indledende snak med dig omkring netop dette. På den måde kan jeg bedst muligt nå i mål med leveringen af en komplet og skræddersyet løsning. Jeg spørger grundigt ind til dine forventninger til opgaven, så vi undgår misforståelser. Jeg holder dig også gerne opdateret fra start til slut, hvis du ønsker det. Det er vigtigt for mig, at mine kunder føler sig trygge gennem hele forløbet.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200/80 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-cyan-50 text-cyan-600 flex items-center justify-center text-xl">
                <i className="fa-solid fa-award" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 tracking-tight">
                Høj kvalitet og god service
              </h3>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Hos mig kan du altid regne med god service og høj kvalitet. Jeg går aldrig fra en opgave, før den er 100% færdig, og før begge parter er tilfredse med resultatet. Jeg overholder alle aftaler og deadlines, så hvis du er på udkig efter kvalitetsløsninger til tiden, så er det mig, du skal kontakte.
              </p>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed pt-2">
                Jeg har den rette faglige viden og kompetencerne til at levere et veludført stykke arbejde. Jeg møder dig altid med et smil, og jeg besvarer med glæde ethvert spørgsmål, som du måtte have i løbet af projektet.
              </p>
            </div>
          </div>

          {/* Callout: Vil du vide mere? */}
          <div className="bg-maritime-900 text-white rounded-2xl p-8 sm:p-10 shadow-xl border border-maritime-800 space-y-4">
            <h4 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              Vil du vide mere?
            </h4>
            <p className="text-slate-200 text-base sm:text-lg leading-relaxed">
              Finder du ikke nok informationer om din ønskede opgave her på hjemmesiden, er du altid meget velkommen til at kontakte mig til en uforpligtende snak og eventuelt et tilbud på opgaven.
            </p>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
              Ring til mig på telefon <a href="tel:+4550510062" className="text-cyan-400 font-bold hover:underline whitespace-nowrap">+45 50 51 00 62</a> eller send en mail til <a href="mailto:johann2@hotmail.com" className="text-cyan-400 font-bold hover:underline whitespace-nowrap">johann2@hotmail.com</a>. Jeg besvarer din henvendelse hurtigst muligt.
            </p>
            <div className="pt-4 flex flex-wrap gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm transition-colors shadow-md"
              >
                <span>Gå til kontaktformular</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Connected CMS Galleri */}
      <GallerySection
        gallerySlug="baadtransport-galleri"
        title="Galleri: Bådtransport på vandet"
        subtitle="Se billeder fra mine transporter og sejlads i de danske farvande."
      />
    </div>
  );
}
